let bitrix = require('../../actions/bitrix');
let order = require('../../signals/order');
let orders = require('../../actions/account/orders');
let currentOrder = require('../../actions/account/current-order');
let error = require('../../actions/error');
let utils = require('../../actions/utils');
let accountUi = require('../../actions/accountUi');
let user = require('../../actions/user');
let content = require('../../actions/layout/content');
let { usingLock } = require('../utils');
let analytics = require('../../actions/analytics');
let form = require('../../signals/form');

let getUser = [
    [
        user.getUser,
        {
            allowed: [
                utils.updateStateFromArg('user', ['user']),
                user.updateUserRole
            ],
            nameResolutionFailure: [
                utils.set(['user', 'role'], 'unauthorized'),
                error.bitrixUnavailableError('user.getUser')
            ],
            trustFailure: [
                utils.set(['user', 'role'], 'unauthorized'),
                error.bitrixCertificateError('user.getUser')
            ],
            denied: [
                utils.set(['user', 'role'], 'unauthorized')
            ]
        }
    ]
];

// после бесплатной выгрузки изменяется цена заказа, счёт-оферта (если есть), нужно их обновить
let exportJobSuccessHandler = [
    utils.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isExportDone'], true),
    [
        utils.isArgEqual('isExportFree', true),
        {
            yes: [
                utils.setArgFromState('orderId', ['account', 'orders', 'currentOrder', 'id']),
                [
                    orders.getOrder,
                    {
                        success: [
                            utils.setArgByFunction('price', (args) => args['currentOrder'].price),
                            utils.setArgByFunction('necessaryDocuments',
                                (args) => args['currentOrder'].necessaryDocuments),
                            utils.setArgByFunction('paymentForm', (args) => args['currentOrder'].paymentForm),
                            utils.setArgByFunction('freeLeadsAmount', (args) => args['currentOrder'].freeLeadsAmount),
                            currentOrder.updateOrder(['price', 'necessaryDocuments', 'paymentForm', 'freeLeadsAmount'])
                        ],
                        notFound: [],
                        error: []
                    }
                ]
            ],
            no: []
        }
    ]
];

let backToOrderPage = [
    utils.unset(['account', 'orders', 'currentOrder', 'showBitrixLeadMapping']),
    utils.unset(['account', 'orders', 'currentOrder', 'bitrixExportLeads'])
];

let exportLeads = [
    [
        bitrix.exportLeads,
        {
            success: [
                // убираем у пользователя возможность делать бесплатные выгрузки
                [
                    utils.isArgEqual('isExportFree', true),
                    {
                        yes: [
                            utils.set(['user', 'isFreeBitrixExportAllowed'], false)
                        ],
                        no: []
                    }
                ],
                [
                    bitrix.getExportJobProgress,
                    {
                        success: [
                            ...exportJobSuccessHandler
                        ],
                        dontNeed: [],
                        error: [ error.internalError('bitrix.getExportJobProgress') ]
                    }
                ]
            ],
            // если халява уже запрещена, но забираем у пользователя право на халяву и показываем ему страницу заказа
            forbidden: [
                utils.unset(['user', 'isFreeBitrixExportAllowed']),
                ...backToOrderPage
            ],
            error: [ error.internalError('bitrix.exportLeads') ]
        }
    ]
];

module.exports = {
    onLoad: [
        [
            utils.isEqual(['bitrix', 'isInit'], true),
            {
                yes: [],
                no: [
                    [
                        bitrix.init,
                        {
                            success: [
                                utils.set(['bitrix', 'isInit'], true)
                            ],
                            error: [ error.internalError('bitrix.init') ]
                        }
                    ],
                    bitrix.fitWindow
                ]
            }
        ],
        [
            utils.isEqual(['user', 'id'], undefined),
            {
                yes: [ ...getUser ],
                no: []
            }
        ],
        ...order.onLoad,
        bitrix.resize
    ],

    getUser,

    exportLeads,

    setIncludeExportedFreeLeads: [
        utils.setFromArgsToState('value', ['account', 'orders', 'currentOrder', 'bitrixExportLeads',
            'isIncludeExportedFreeLeads'])
    ],

    setBitrixRequiredFieldValue: [
        bitrix.setBitrixRequiredFieldValue,
        bitrix.validateMapping
    ],

    exportLeadsUsingMapping: [
        ...usingLock(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'exportLeadsProgressLock'], [
            bitrix.addLeadMappingToArgs,
            [
                utils.isArgEqual('isExportFree', true),
                {
                    yes: [
                        analytics.argsValueEvent({ category: 'button_bitrix_export_free', action: 'click' })
                    ],
                    no: []
                }
            ],
            [
                utils.isDefined(['account', 'orders', 'currentOrder', 'bitrixExportLeads',
                    'requiredBitrixFields']),
                {
                    yes: [
                        analytics.argsValueEvent({ category: 'button_bitrix_export_w_required_fields',
                            action: 'click' })
                    ],
                    no: []
                }
            ],
            ...exportLeads
        ])
    ],

    backToOrderPage,

    redirectToLeadsMapping: [
        utils.set(['account', 'orders', 'currentOrder', 'showBitrixLeadMapping'], true),
        content.setIsLoading(true),
        [
            bitrix.getLeadFields,
            {
                success: [
                    bitrix.initBitrixLeads,
                    bitrix.validateMapping,
                    [
                        utils.isDefined(['account', 'orders', 'currentOrder', 'bitrixExportLeads',
                            'requiredBitrixFields']),
                        {
                            yes: [
                                analytics.argsValueEvent({ category: 'bitrix_required_fields_are_shown',
                                    action: 'see' })
                            ],
                            no: []
                        }
                    ]
                ],
                error: [ error.internalError('bitrix.getLeadFields') ]
            }
        ],
        utils.setFromArgsToState('isExportFree', ['account', 'orders', 'currentOrder', 'bitrixExportLeads',
            'isExportFree']),
        content.setIsLoading(false),
        bitrix.scrollTop
    ],

    selectHermesToBitrixLeadMapping: [
        bitrix.selectBitrixLeadField,
        bitrix.validateMapping
    ],

    selectHermesLeadRequiredValue: [
        utils.setArgByFunction('optionsPath', (args) => ['account', 'orders', 'currentOrder', 'bitrixExportLeads',
            'requiredFields', args.field, 'enumValues']),
        accountUi.selectChanged,
        utils.setFromArgsToState('selectedValue',
            'account.orders.currentOrder.bitrixExportLeads.requiredFields.${id}.value', { id: 'field' }),
        bitrix.validateMapping
    ],

    toogleFieldMappingIsNew: [
        utils.toggleBoolFromArgs,
        bitrix.validateMapping
    ],

    inputTextWithValidateMapping: [
        ...form.inputText,
        bitrix.validateMapping
    ],

    blurTextWithValidateMapping: [
        ...form.blurText,
        bitrix.validateMapping
    ],

    validateMapping: [
        bitrix.validateMapping
    ],

    setDate (basePath) {
        return [
            accountUi.setDate(basePath),
            bitrix.validateMapping
        ];
    },

    unsetDate (basePath) {
        return [
            accountUi.unsetDate(basePath),
            bitrix.validateMapping
        ];
    },

    resize: [
        bitrix.resize
    ],

    resizeIfAccountPage: [
        [
            utils.isEqual(['page', 'name'], 'account'),
            {
                yes: [ bitrix.resize ],
                no: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/bitrix/index.js